import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'dropdown-card',
  templateUrl: './dropdown-card.component.html',
  styleUrls: ['./dropdown-card.component.scss'],
  standalone: false,
})
export class DropdownCardComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
